import { forwardRef, useEffect, useState } from "react"
import { TextInput as RNTextInput, TextInputProps, BlurEvent } from "react-native"
import { TextInput } from "components/core"
import { arabicToEnglishNumbers, priceToDBFormat } from "@white-labels/utils"

type PriceInputProps = Omit<TextInputProps, "value" | "onChangeText"> & {
  value: number | undefined
  onValueChange: (value: number | undefined) => void
}

function _formatValue(value: number | undefined) {
  return value ? (value / 1000).toString() : ""
}

export const PriceInput = forwardRef<RNTextInput, PriceInputProps>(function PriceInput({ value, onValueChange, onBlur, ...props }, ref) {
  const [_value, _setValue] = useState(() => _formatValue(value))

  useEffect(() => {
    _setValue(_formatValue(value))
  }, [value])

  const handleChangeText = (raw: string) => {
    const text = arabicToEnglishNumbers(raw).trim()
    if (/^\d*\.?\d{0,3}$/.test(text)) {
      _setValue(text)
      if (text === "") {
        onValueChange(undefined)
      } else if (!text.endsWith(".") && text !== ".") {
        const num = parseFloat(text)
        if (!Number.isNaN(num)) onValueChange(priceToDBFormat(num))
      }
    }
  }

  const handleBlur = (e: BlurEvent) => {
    const cleaned = _value.endsWith(".") ? _value.slice(0, -1) : _value
    if (cleaned === "") {
      _setValue("")
      onValueChange(undefined)
    } else {
      const num = parseFloat(cleaned)
      if (!Number.isNaN(num)) {
        _setValue(cleaned)
        onValueChange(priceToDBFormat(num))
      }
    }
    onBlur?.(e)
  }

  return (
    <TextInput
      ref={ref}
      value={_value}
      selectTextOnFocus
      onChangeText={handleChangeText}
      onBlur={handleBlur}
      keyboardType="numeric"
      autoCorrect={false}
      placeholder="0.00"
      {...props}
    />
  )
})
